import GlobalButton from "../../Utils/GlobalUtilsComponents/GlobalButton"
import sneakerIcon from "../../assets/Images/Profile/sneakerIcon.svg"
import editIcon from "../../assets/Images/Profile/pencilIcon.svg"
import { useContext, useEffect, useState } from "react"
import { ProfileContext, ProfileContextPayload } from "../../Context/ProfileDetailsContext"
import { Grid, IconButton, Typography } from "@mui/material"
import IconsColor from "../../Utils/IconsColor"
import { Outlet, useLocation, useNavigate } from "react-router-dom"
import globalStyles from "../../Styles/ComponentStyles/global.module.scss"
import styles from '../../Styles/ComponentStyles/ProfileStyle/ProfileDetails.module.scss'
import GlobalPopUp from "../../GlobalComponent/GlobalPopup/GlobalPopup"
import RegisterProfile from "../../GlobalComponent/RegisterProfile/RegisterProfile"
import ErrorShowingDialog from "../../GlobalComponent/ErrorShowingDialog/ErrorShowingDialog"
import { UserContext, UserContextPayload } from "../../Context/UserDetailContext"
import KickitLinkPopupWrapper from "../../GlobalComponent/KickitLinkPopup/KickitLinkPopupWrapper"
import chartIcon from "../../assets/Images/chartIcon.svg"
import tableIcon from "../../assets/Images/tableIcon.svg"
import agent from "../../service/api"
import { useSnackbar } from "../../GlobalComponent/GlobalSnackbar/GlobalSnackbar"
import GlobalTabsComponent from "../../GlobalComponent/GlobalTabsComponent/GlobalTabsComponent"
import { downloadPdfFromBase64 } from "../../Utils/downloadPdf"

const IULProfilesOutputWrapper = () => {

    const navigate = useNavigate();
    const location = useLocation();

    const { showSnackbar } = useSnackbar();

    const queryParams = new URLSearchParams(location.search);
    const userId = queryParams.get('user_id') || '';
    const tabValue = queryParams.get('tab')

    const {
        setFlagOpenRegisterProfileDialog,
        flagOpenRegisterProfileDialog,
        profileName,
        flagInvalidInputError,
        setFlagInvalidInputError,
        setProfileName,
        getparticularUserProfileDetail,
        setFinalData,
        setIulFeesbtnToggled,
        iulFeesbtnToggled
    } = useContext(ProfileContext) as ProfileContextPayload;

    const {
        setFlagLoader
    } = useContext(UserContext) as UserContextPayload

    const [tabNavigationValue, setTabNavigationValue] = useState(tabValue);
    const [flagKickitBtnClicked, setFlagKickitBtnClicked] = useState(false);
    const [isSampleProfile, setIsSampleProfile] = useState(false);
    const [userEmail, setUserEmail] = useState<string>('');
    const [isDataLoaded, setIsDataLoaded] = useState(false);

    const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
        setTabNavigationValue(newValue);

        switch (newValue) {
            case '1':
                navigate(`/profile/iulProfileDetails/sp?user_id=${userId}&tab=1`);
                break;
            case '2':
                navigate(`/profile/iulProfileDetails/accountValue?user_id=${userId}&tab=2`);
                break;
            case '3':
                navigate(`/profile/iulProfileDetails/retirementIncome?user_id=${userId}&tab=3`);
                break;
            case '4':
                navigate(`/profile/iulProfileDetails/taxes?user_id=${userId}&tab=4`);
                break;
            case '5':
                setIulFeesbtnToggled(false);
                navigate(`/profile/iulProfileDetails/fees?user_id=${userId}&tab=5`);
                break;
        }
    };

    const fetchParticularUserProfileDetail = async () => {
        try {
            setFlagLoader(true);
            const response = await getparticularUserProfileDetail(userId);
            if (response?.status) {
                if (response?.inputData) {
                    setProfileName(response?.inputData?.[0]?.universalInput?.firstName);
                    setUserEmail(response?.inputData?.[0]?.universalInput?.email);
                    setIsSampleProfile(response?.inputData?.[0]?.sample_profile);
                    setFinalData(response?.data?.[0]);
                }
                const isInvalidInputError = response?.data?.[0]?.error?.code === 9038;
                setFlagInvalidInputError(isInvalidInputError);
            } else {
                console.log("error fetching data");
            }
        } catch (error) {
            console.error('Error fetching user profile:', error);
            showSnackbar('Something went wrong!', 'error');
        } finally {
            setFlagLoader(false);
            setIsDataLoaded(true);
        }
    };

    const handleEditProfileClick = async () => {
        navigate(`/profile/newProfile/iul?user_id=${userId}`);
    }

    const handleFeesChartBtnToggle = () => {
        setIulFeesbtnToggled(!iulFeesbtnToggled)
    }

    const handleExportAsPdfBtnClick = async () => {
        try {
            setFlagLoader(true);
            const response = await agent.downloadProfilePdfAPI.get(userId);

            if (response?.status && response?.data?.pdfBase64) {
                const { fileName, pdfBase64 } = response.data;
                await downloadPdfFromBase64(pdfBase64, fileName);
            } else {
                showSnackbar(response?.error?.message || "Something went wrong!", "error")
            }
        } catch (error) {
            console.error('Error exporting profile PDF:', error);
            showSnackbar("Something went wrong!", "error")
        } finally {
            setFlagLoader(false);
        }
    }

    const renderActionButtons = () => {
        if (!isDataLoaded) return null;

        return (
            <Grid item>
                <Grid container gap={"10px"}>
                    {
                        isSampleProfile &&
                        <span
                            style={{
                                color: "#008236",
                                backgroundColor: "#DCFCE7",
                                border: "none",
                                borderRadius: "14px",
                                fontSize: "13px",
                                fontWeight: 600,
                                textAlign: "center",
                                padding: "10px"
                            }}
                        >
                            Sample Profile
                        </span>
                    }
                    {!isSampleProfile && !flagInvalidInputError &&
                        <Grid item>
                            <GlobalButton
                                value="KickIt"
                                className={styles.shareBtn}
                                startIcon={<img src={sneakerIcon} alt=''></img>}
                                onClick={() => setFlagKickitBtnClicked(true)}
                            />
                        </Grid>
                    }
                    <Grid item>
                        <GlobalButton
                            value="Export As PDF"
                            className={styles.quickEditBtn}
                            onClick={() => {
                                handleExportAsPdfBtnClick()
                            }}
                        />
                    </Grid>
                    <Grid item>
                        <GlobalButton
                            value="Edit"
                            className={styles.editBtn}
                            startIcon={<img src={editIcon} alt='' />}
                            onClick={() => {
                                setFlagInvalidInputError(false)
                                handleEditProfileClick()
                            }}
                        />
                    </Grid>
                </Grid>
            </Grid>
        );
    };

    useEffect(() => {
        fetchParticularUserProfileDetail();
    }, [])

    return (
        <>
            {flagOpenRegisterProfileDialog &&
                <GlobalPopUp
                    open={flagOpenRegisterProfileDialog}
                    onClose={() => { setFlagOpenRegisterProfileDialog(false) }}
                    title='New Profile'
                    showCloseIcon={true}
                    flagDivider
                    maxWidth="sm"
                >
                    <RegisterProfile />
                </GlobalPopUp>
            }

            {flagKickitBtnClicked &&
                <GlobalPopUp
                    open={flagKickitBtnClicked}
                    onClose={() => { setFlagKickitBtnClicked(false) }}
                    title='KickIt'
                    showCloseIcon={true}
                    flagDivider
                    maxWidth="sm"
                >
                    <KickitLinkPopupWrapper
                        userProfileId={userId}
                        userEmail={userEmail}
                        setFlagKickitBtnClicked={setFlagKickitBtnClicked}
                    />
                </GlobalPopUp>
            }

            <div style={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                overflow: 'hidden',
            }}>
                {/* Sticky Header Section */}
                {(tabValue) &&
                    <div style={{
                        flexShrink: 0,
                        backgroundColor: '#fff',
                        zIndex: 50,
                    }}>
                        <Grid container >
                            <Grid item xs={12}>
                                <Grid container alignItems={"center"} justifyContent={"space-between"} padding={"20px"}>
                                    <Grid item>
                                        <Grid container alignItems={"center"} gap={'10px'}>
                                            <Grid item>
                                                <IconButton
                                                    onClick={() => {
                                                        setFlagInvalidInputError(false)
                                                        navigate(-1)
                                                    }}>
                                                    <IconsColor iconName="backArrow" color={"#45556C"} />
                                                </IconButton>
                                            </Grid>
                                            <Grid item>
                                                <Typography component={"span"} className={styles.profileName}>
                                                    {profileName}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    {renderActionButtons()}
                                </Grid>
                            </Grid>
                            <Grid item xs={12} borderBottom={'1px solid #E2E8F0'} padding={"0px 20px"}>
                                <Grid container justifyContent={"space-between"} alignItems={"center"} className={styles.tabsWrapper}>
                                    <Grid item>
                                        <GlobalTabsComponent
                                            value={tabNavigationValue || '1'}
                                            onChange={handleTabChange}
                                            tabs={[
                                                { label: "S&P Comparison", value: "1" },
                                                { label: "Account Value", value: "2" },
                                                { label: "Retirement Income", value: "3" },
                                                { label: "Taxes", value: "4" },
                                                { label: "Fees", value: "5" },
                                            ]}
                                        />
                                    </Grid>
                                    {tabNavigationValue === '5' && !flagInvalidInputError &&
                                        <Grid item>
                                            <GlobalButton
                                                value={iulFeesbtnToggled ? "View Details" : "Typical vs IUL Fees"}
                                                className={styles.chartBtn}
                                                startIcon={
                                                    <img src={iulFeesbtnToggled ? tableIcon : chartIcon} alt="" />
                                                }
                                                onClick={handleFeesChartBtnToggle}
                                            />
                                        </Grid>
                                    }
                                </Grid>
                            </Grid>
                        </Grid>
                    </div>
                }

                {/* Scrollable Content Section */}
                <div style={{
                    flexGrow: 1,
                    overflow: 'auto',
                    padding: "20px"
                }}>
                    {flagInvalidInputError &&
                        <Grid container>
                            <Grid item xs={12} mt={2} className={globalStyles.errorDialogStyle}>
                                <ErrorShowingDialog />
                            </Grid>
                        </Grid>
                    }
                    <Outlet />
                </div>
            </div>
        </>
    )
}

export default IULProfilesOutputWrapper